<highcharts-chart class="charts_height mt-0"
   [Highcharts] = "highcharts"
   [options] = "chartOptions"
   class = "w-100 d-block charts_height">
</highcharts-chart>
